<script>
import axios from '@/utils/axios';
import { vendorsList } from '@/utils/vendor';
import { warehousesList } from '@/utils/warehouse';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import StatusBadge from '@/components/common/purchase-order-status-badge.vue';
import { clientSetting } from '@/utils/auth';
import { Modal } from 'bootstrap';
import ItemModal from '@/components/modal/item-modal.vue';

export default {
  components: {
   StatusBadge,
   ItemModal
  },
  inject: ['setLoading'],
  data() {
    return {
      id: '',
      ids: [],
      status: '',
      vendor_id: '',
      warehouse_id: '',
      notes: '',
      taxes: [],
      vendors: [],
      warehouses: [],
      allItems: [],
      deleteToken: null,
      items: [
        { item: null, hsn_code: '', price: 0, qty: 1, amount: 0 }
      ],
      loading: false,
      editorConfig: {},
      editor: ClassicEditor,
      action: '',
      app_currency: '',
      mass_delete: false,
      errors: {},
      po_number: '',
      expected_date: '',
      activities: [],
      selectedTax: null,
      showReceiveModal: false,
      poReceiveData: null,
      poReceiveId: null,
      poReceiveNumber: '',
      receivedQuantities: {},
      receivedPrices: {},
      pendingItemRowIndex: null,
      receiveInvoiceNumber: '',   
      receiveInvoiceFiles: [], 
      receiveInvoiceErrors: {}, 
      module_url: 'inventory/purchase-orders',
    };
  },

  computed: {

   totalAmount(){
    return this.items.reduce((sum, row) => sum + row.amount, 0);
   },

   taxAmount() {
     // Item mode - sum taxes from individual items using selectedTax
     return this.items.reduce((sum, row) => {
      const itemTaxRate = row.selectedTax?.rate || 0;
      return sum + (row.amount * itemTaxRate / 100);
     }, 0);
   },

   grandTotal(){
    const discountAmount = 0;
    const shippingAmount = 0;
    return Math.max(0, this.totalAmount - discountAmount) + this.taxAmount + shippingAmount;
   },

  },

  async mounted(){  
   this.getTaxes(); 
   this.allVendors();
  //  this.getAllItems();  
   this.allWarehouses();
   this.app_currency = await this.$appCurrency();
  },

  methods: {

    async onVendorChange() {
  this.allItems = [];
  this.items = [{ item: null, selectedTax: null, hsn_code: '', price: 0, qty: 1, amount: 0 }];
  
  if (!this.vendor_id) return;

  try {
    const res = await axios.get(`/items/${this.vendor_id}/by-vendor`);
    this.allItems = res.data.data || [];
  } catch (error) {
    this.$swalToast('Failed to load vendor items', 'error');
  }
},

// openAddItemModal(rowIndex) {
//   this.pendingItemRowIndex = rowIndex;
//   const modalEl = document.getElementById('item_modal');
//   const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
//   modal.show();
// },

openAddItemModal(rowIndex) {
  this.pendingItemRowIndex = rowIndex;
  this.$refs.itemModalRef.add();
  
  const modalEl = document.getElementById('item_modal');
  const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
  modal.show();
},


async onItemAdded(newItemData = null) {
  await this.getAllItems();

  if (this.pendingItemRowIndex !== null) {
    
    const newItem = newItemData?.id
      ? this.allItems.find(i => i.id === newItemData.id)
      : this.allItems[this.allItems.length - 1]; // fallback

    const row = this.items[this.pendingItemRowIndex];
    if (row && newItem) {
      this.onItemSelected(this.pendingItemRowIndex, newItem);
      row.item = newItem;
    }
    this.pendingItemRowIndex = null;
  }
},

  async purchaseOrderActivity(row){
   this.status = row.status;
   this.po_number = row.po_number; 
   this.activities = row.activities;
  },

  async purchaseOrder(public_token = null){
   this.setLoading(true);
   try{
    this.resetForm();
    this.getTaxes();
    this.getAllItems();

if(public_token !== null){
    const response = await axios.get(`/${this.module_url}/${public_token}/by-token`);
    const data = response.data.data;

    if (data.vendor_id) {
      this.vendor_id = data.vendor_id;
      await this.onVendorChange();
    }

    this.id = data.id;
    this.notes = data.notes || '';
    this.vendor_id = data.vendor_id;
    this.warehouse_id = data.warehouse_id;
    this.expected_date = data.expected_date || '';
    this.selectedTax = this.taxes.find(t => t.id === data.tax_id) || null;

    // Populate items
    this.items = data.purchase_order_items.map(row => {
     const selectedItem = this.allItems.find(i => i.id === row.item_id);
     const unitPrice = parseFloat(row.unit_price || row.price || 0);
     const qty = parseFloat(row.quantity_ordered || 1);
     const selectedTax = row.tax_id ? this.taxes.find(t => t.id === row.tax_id) : null;
     
      return {
       item: selectedItem || { id: row.item_id, name: row.name },
       selectedTax: selectedTax,
       hsn_code: row.hsn_code || '',
       price: unitPrice,
       qty: qty,
       amount: unitPrice * qty
     };
     });
    }
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

   async allVendors(){
    this.setLoading(true);
    try{
     const response = await vendorsList();
     this.vendors = response.data.data;   
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   },

   async allWarehouses(){
    this.setLoading(true);
    try{
     const response = await warehousesList();
     this.warehouses = response.data.data;   
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   },  

   async getAllItems(){
    try{
     const res = await axios.get('/items/dropdown');
     this.allItems = res.data.data;
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   },
    
   addItemRow(){
    this.items.push({ item: null, selectedTax: null, hsn_code: '', price: 0, qty: 1, amount: 0 });
   },
   
   removeItemRow(index){
    if (this.items.length === 1) return;
    this.items.splice(index, 1);
   },

   onItemSelected(index, selectedItem){
    const row = this.items[index];
    if(!selectedItem){
     row.item = null;
     row.selectedTax = null;
     row.hsn_code = '';
     row.price = 0;
     row.qty = 1;
     row.amount = 0;
     return;
    }
  
    row.hsn_code = selectedItem.hsn_code || '';
    row.price = parseFloat(selectedItem.price || 0);
    row.qty = 1;
  
    // Set the tax for this item if it exists
    if(!row.selectedTax && selectedItem.tax_id){
     row.selectedTax = this.taxes.find(t => t.id === selectedItem.tax_id);
    }

    this.updateAmount(index);
   },

updateAmount(index) {
  const row = this.items[index];
  const price = parseFloat(row.price) || 0;
  const qty = parseFloat(row.qty) || 0;
  row.amount = qty * price;
},


    async getTaxes(){
     this.setLoading(true);
     try{
      const response = await axios.get('/taxes');
      this.taxes = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    async savePurchaseOrder() {
     this.errors = {};
     this.setLoading(true);
       const invalidItem = this.items.find(row => !row.qty || parseFloat(row.qty) < 1);
          if (invalidItem) {
            this.$swalToast('Quantity must be at least 1 for all items', 'warning');
            this.setLoading(false);
            return;
          }
      try{ 
       const payload = {
        notes: this.notes,
        vendor_id: this.vendor_id,
        warehouse_id: this.warehouse_id,
        expected_date: this.expected_date,
        tax_id: this.selectedTax?.id || null,
        items: this.items.map(row => ({
         item_id: row.item?.id || null,
         name: row.item?.name,
         hsn_code: row.hsn_code === 'null' || row.hsn_code === '' || row.hsn_code == null ? null : row.hsn_code,
         quantity_ordered: row.qty,
         unit_price: row.price,
         tax_id: row.selectedTax?.id || null
        }))
       };

       let response;
       if(this.id){
        response = await axios.put(`/${this.module_url}/${this.id}`, payload);
       }else{
        response = await axios.post(`/${this.module_url}`, payload);
       }

       this.$swalToast(response.data.message);
       this.$emit('updated');

       this.$closeModal('purchase_order_modal');
       this.resetForm();

      }catch(error){
       if(error?.type === 'validation'){
        this.errors = error.errors;
       }else{
        this.$swalToast(error.message, 'error');
       }
      }finally{
       this.setLoading(false);
      }
    },

async deletePurchaseOrder(public_token = null){
  this.deleteToken = public_token;  
},
async confirmDelete(){
  this.errors = {};
  this.setLoading(true);
  try{
    const response = await axios.delete(`/${this.module_url}/${this.deleteToken}`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.$closeModal('purchase_order_delete_modal');
  }catch(error){
    if(error.type == 'validation'){
      this.errors = error.errors;
    }else{
      this.$swalToast(error.message, 'error');
    }
  }finally{
    this.setLoading(false);
  }
},

    getItemError(index, field){
     const key = `items.${index}.${field}`;
     return this.errors[key] ? this.errors[key][0] : null;
    },

    getItemAmountDisplay(item) {
     const taxRate = item.selectedTax?.rate || 0;
     return item.amount * (1 + (taxRate / 100));
    },

    bulkAction(ids){
     this.ids = ids;
    },

   onItemTaxSelected(index, selectedTax){
    const row = this.items[index];
    row.selectedTax = selectedTax;
  
    // Update the item's tax reference for calculations
    if(selectedTax){
     row.item = row.item || {};
     row.item.tax = selectedTax;
     row.item.tax_id = selectedTax.id;
    }else{
     if (row.item) {
      row.item.tax = null;
      row.item.tax_id = null;
     }
    }
    // Recalculate amount if needed
    this.updateAmount(index);
   },

   async receiveStock(row){
    this.setLoading(true);
    this.id = row.id;
    this.po_number = row.po_number;
    try{
     const response = await axios.get(`/${this.module_url}/${this.id}`);
     const data = response.data.data; 
    }catch(error){
     this.$swalToast(error.message);
    }finally{
     this.setLoading(false); 
    }
   },

   async receiveStock(row) {
    this.setLoading(true);
    this.poReceiveId = row.id;
    this.poReceiveNumber = row.po_number;
    this.receiveInvoiceNumber = '';
    this.receiveInvoiceFiles = [];
    this.receiveInvoiceErrors = {};
  
    try{
     const response = await axios.get(`/${this.module_url}/${row.id}`);
     const data = response.data.data;
    
     this.poReceiveData = data;
     // Pre-fill input values with PO data
     data.purchase_order_items.forEach(poItem => {
      this.receivedQuantities[poItem.id] = 0;
      this.receivedPrices[poItem.id] = parseFloat(poItem.unit_price);
     });

    }catch(error){
     this.$swalToast('Error loading PO', 'error');
    }finally{
     this.setLoading(false);
    }
   },

// ✅ PURA REPLACE KARO
async saveReceivedStock() {
  this.receiveInvoiceErrors = {};

  if (!this.receiveInvoiceNumber) {
    this.receiveInvoiceErrors.invoice_number = ['Invoice number is required'];
    return;
  }
  // if (!this.receiveInvoiceImage) {
  //   this.receiveInvoiceErrors.invoice_image = ['Invoice image is required'];
  //   return;
  // }
if (!this.receiveInvoiceFiles.length) {
  this.receiveInvoiceErrors.invoice_files = ['At least one invoice file is required'];
  return;
}

  this.setLoading(true);
  try {
    const formData = new FormData();
    formData.append('purchase_order_id', this.poReceiveId);
    formData.append('invoice_number', this.receiveInvoiceNumber);
    this.receiveInvoiceFiles.forEach((file) => {
      formData.append('invoice_files[]', file);
    });

    this.poReceiveData.purchase_order_items.forEach((item, index) => {
      const qty = parseFloat(this.receivedQuantities[item.id]) || 0;
      const price = parseFloat(this.receivedPrices[item.id]) || parseFloat(item.unit_price);
      formData.append(`received_items[${index}][purchase_order_item_id]`, item.id);
      formData.append(`received_items[${index}][quantity_received]`, qty);
      formData.append(`received_items[${index}][unit_price]`, price);
    });

    const response = await axios.post('/inventory/stocks/receive-po', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    this.$swalToast('Stock received successfully');
    this.$closeModal('purchase_order_receive_stock_modal');
    this.$emit('updated');

    // Reset
    this.receiveInvoiceNumber = '';
    this.receiveInvoiceFiles = [];
    this.receiveInvoiceErrors = {};
    if (this.$refs.receiveInvoiceInput) {
  this.$refs.receiveInvoiceInput.value = '';
}

  } catch (error) {
    if (error?.type === 'validation') {
      this.receiveInvoiceErrors = error.errors;
    } else {
      this.$swalToast(error.message || 'Error receiving stock', 'error');
    }
  } finally {
    this.setLoading(false);
  }
},

// handleReceiveInvoiceImage(event) {
//   const file = event.target.files[0];
//   if (file) {
//     this.receiveInvoiceImage = file;
//   }
// },

handleReceiveInvoiceFiles(event) {
  const files = Array.from(event.target.files || []);
  const allowed = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'application/pdf'];

  for (const file of files) {
    if (!allowed.includes(file.type)) {
      this.$swalToast(`${file.name}: only images or PDF allowed`, 'warning');
      continue;
    }
    // duplicate check (same name + size)
    const exists = this.receiveInvoiceFiles.some(
      f => f.name === file.name && f.size === file.size
    );
    if (!exists) {
      this.receiveInvoiceFiles.push(file);
    }
  }

  // input clear so same file dobara add ho sake
  event.target.value = '';
},

removeReceiveFile(index) {
  this.receiveInvoiceFiles.splice(index, 1);
},

    resetForm() {
     this.id = null;
     this.notes = '';
     this.vendor_id = '';
     this.warehouse_id = '';
     this.expected_date = '';
     this.status = null;
     this.selectedTax = null;
     this.items = [{ item: null, selectedTax: null, hsn_code: '', price: 0, qty: 1, amount: 0 }];
     this.errors = {};
    }
  }
};
</script>


<style scoped>
/* ─────────────────────────────────────────────
   PURCHASE ORDER MODAL — REDESIGNED UI STYLES
   Logic is 100% untouched. Visual only.
───────────────────────────────────────────── */
 
/* Main area */
.po-main {
  flex: 1; display: flex; flex-direction: column; overflow: hidden;
  background: #f1f5f9;
}
 
/* Topbar */
.po-topbar {
  background: #fff; border-bottom: 1px solid #e2e8f0;
  padding: 12px 22px;
  display: flex; align-items: center; justify-content: space-between;
  flex-shrink: 0;
}
.po-page-title { font-size: 14px; font-weight: 700; color: #0f172a; }
.po-page-sub { font-size: 11px; color: #94a3b8; }
.po-close-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #f1f5f9; border: 1px solid #e2e8f0;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; color: #64748b; font-size: 13px; transition: all .15s;
}
.po-close-btn:hover { background: #fee2e2; border-color: #fca5a5; color: #ef4444; }
 
/* Scrollable body */
.po-body {
  flex: 1; overflow-y: auto; padding: 18px 22px;
  scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent;
}
.po-body::-webkit-scrollbar { width: 4px; }
.po-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
 
/* Section cards */
.po-card {
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 12px; margin-bottom: 14px;
}
.po-card-head {
  display: flex; align-items: center; gap: 9px;
  padding: 10px 16px; background: #f8fafc;
  border-bottom: 1px solid #e8edf3;
}
.po-card-icon {
  width: 24px; height: 24px; border-radius: 6px;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; flex-shrink: 0;
}
.po-card-title { font-size: 12px; font-weight: 700; color: #0f172a; }
.po-card-body { padding: 14px 16px; }
 
/* Form controls */
.po-label {
  font-size: 11px; font-weight: 600; color: #475569;
  margin-bottom: 4px; display: block;
}
.po-label .req { color: #f43f5e; margin-left: 2px; }
.po-input, .po-select, .po-textarea {
  width: 100%; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 11px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none;
  transition: border-color .15s, box-shadow .15s;
}
.po-input, .po-select { height: 35px; }
.po-textarea { padding: 8px 11px; resize: vertical; min-height: 80px; }
.po-input:focus, .po-select:focus, .po-textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1);
}
.po-input.err { border-color: #f43f5e; box-shadow: 0 0 0 3px rgba(244,63,94,.1); }
.po-err-msg {
  font-size: 10.5px; color: #f43f5e; margin-top: 3px;
  display: flex; align-items: center; gap: 3px;
}
 
/* Item row */
.po-item-card {
  background: #fff; border: 1.5px solid #e8edf3;
  border-radius: 10px; padding: 14px 14px 10px;
  margin-bottom: 10px; position: relative;
  transition: border-color .15s, box-shadow .15s;
}
.po-item-card:hover { border-color: #bfdbfe; box-shadow: 0 2px 10px rgba(59,130,246,.07); }
.po-item-num {
  position: absolute; top: -9px; left: 14px;
  width: 19px; height: 19px; background: #3b82f6; color: #fff;
  border-radius: 50%; font-size: 9px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
}
.po-remove-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #fff0f3; border: 1.5px solid #fecdd3;
  color: #f43f5e; font-size: 13px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.po-remove-btn:hover { background: #f43f5e; border-color: #f43f5e; color: #fff; }
 
/* Add item button */
.po-add-item-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 14px; background: #eff6ff;
  border: 1.5px dashed #93c5fd; border-radius: 8px;
  color: #2563eb; font-size: 11.5px; font-weight: 600;
  cursor: pointer; transition: all .15s; text-decoration: none;
}
.po-add-item-btn:hover { background: #dbeafe; border-color: #3b82f6; }
 
/* Add new item link inside label */
.po-add-item-link {
  font-size: 10.5px; color: #3b82f6; font-weight: 600;
  text-decoration: none; display: flex; align-items: center; gap: 2px;
  transition: color .15s;
}
.po-add-item-link:hover { color: #1d4ed8; }
 
/* Pricing summary */
.po-price-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 7px 0; border-bottom: 1px dashed #f1f5f9;
}
.po-price-row:last-of-type { border-bottom: none; }
.po-price-label { font-size: 12px; color: #64748b; font-weight: 500; }
.po-price-val { font-size: 12.5px; font-weight: 700; color: #1e293b; }
.po-grand-box {
  display: flex; align-items: center; justify-content: space-between;
  background: linear-gradient(135deg,#0f172a,#1e3a5f);
  border-radius: 10px; padding: 13px 18px; margin-top: 10px;
}
.po-grand-label { font-size: 12.5px; font-weight: 700; color: #93c5fd; display: flex; align-items: center; gap: 6px; }
.po-grand-val { font-size: 18px; font-weight: 800; color: #fff; letter-spacing: -.5px; }
 
/* Action footer */
.po-footer {
  background: #fff; border-top: 1px solid #e2e8f0;
  padding: 11px 22px; display: flex; align-items: center; gap: 8px; flex-shrink: 0;
}
 
/* Reusable buttons */
.po-btn {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 7px 15px; border-radius: 8px; font-size: 12px;
  font-weight: 600; cursor: pointer; border: 1.5px solid transparent;
  transition: all .15s; text-decoration: none; white-space: nowrap;
}
.po-btn-primary {
  background: linear-gradient(135deg,#2563eb,#3b82f6);
  color: #fff; border-color: #2563eb;
  box-shadow: 0 2px 8px rgba(37,99,235,.25);
}
.po-btn-primary:hover { background: linear-gradient(135deg,#1d4ed8,#2563eb); }
.po-btn-success { background: #fff; color: #16a34a; border-color: #86efac; }
.po-btn-success:hover { background: #f0fdf4; border-color: #16a34a; }
.po-btn-ghost { background: #f8fafc; color: #475569; border-color: #e2e8f0; }
.po-btn-ghost:hover { background: #f1f5f9; }
.po-btn-danger { background: #f43f5e; color: #fff; border-color: #f43f5e; }
.po-btn-danger:hover { background: #e11d48; border-color: #e11d48; }
 
/* vue-select theming */
:deep(.vs__dropdown-toggle) {
  border: 1.5px solid #e2e8f0 !important; border-radius: 8px !important;
  min-height: 35px !important; padding: 0 8px !important;
  transition: border-color .15s, box-shadow .15s !important;
}
:deep(.vs__dropdown-toggle:focus-within) {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1) !important;
}
:deep(.vs__search) { font-size: 12.5px !important; color: #1e293b !important; }
:deep(.vs__selected) {
  font-size: 12px !important; color: #1e293b !important;
  background: #eff6ff !important; border: 1px solid #bfdbfe !important;
  border-radius: 5px !important;
}
 
/* Receive Stock modal table */
.po-receive-table th {
  font-size: 11px; font-weight: 700; color: #475569;
  background: #f8fafc; padding: 10px 12px;
  text-transform: uppercase; letter-spacing: .4px;
}
.po-receive-table td {
  font-size: 12.5px; color: #1e293b; padding: 10px 12px;
  vertical-align: middle;
}
.po-receive-table tr:hover td { background: #f8fafc; }
</style>
 
 
<template>
 
<!-- ═══════════════════════════════════════════════
     ADD / EDIT PURCHASE ORDER — FULLSCREEN MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="purchase_order_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen" style="margin:0;">
    <div class="modal-content border-0 h-100" style="border-radius:0; display:flex; flex-direction:column;">
 
      <!-- Topbar -->
      <div class="po-topbar">
        <div>
          <div class="po-page-title">{{ id ? 'Edit Purchase Order' : 'Create Purchase Order' }}</div>
          <div class="po-page-sub">{{ id ? 'Update purchase order details below' : 'Fill in details to generate a new purchase order' }}</div>
        </div>
        <button type="button" class="po-close-btn" data-bs-dismiss="modal">
          <i class="ti ti-x"></i>
        </button>
      </div>
 
      <!-- Form -->
      <form @submit.prevent="savePurchaseOrder" style="flex:1; display:flex; flex-direction:column; overflow:hidden;">
 
        <div class="po-body">
 
          <!-- ── PO Details ── -->
          <div class="po-card">
            <div class="po-card-head">
              <div class="po-card-icon" style="background:#eff6ff;"><i class="ti ti-file-invoice" style="color:#3b82f6;"></i></div>
              <span class="po-card-title">Purchase Order Details</span>
            </div>
            <div class="po-card-body">
              <div class="row g-3">
 
                <div class="col-md-4">
                  <label class="po-label">Warehouse <span class="req">*</span></label>
                  <vue-select
                    v-model="warehouse_id"
                    :options="warehouses"
                    :get-option-label="warehouse => `${warehouse.name} - ${warehouse.code}`"
                    :reduce="w => w.id"
                    placeholder="Select warehouse"
                  />
                  <div v-if="errors.warehouse_id" class="po-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.warehouse_id[0] }}</div>
                </div>
 
                <div class="col-md-4">
                  <label class="po-label">Vendor <span class="req">*</span></label>
                  <vue-select
                    v-model="vendor_id"
                    :options="vendors"
                    :get-option-label="vendor => `${vendor.name} - ${vendor.code}`"
                    :reduce="v => v.id"
                    placeholder="Select vendor"
                    @update:modelValue="onVendorChange"
                    />
                  <div v-if="errors.vendor_id" class="po-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.vendor_id[0] }}</div>
                </div>
 
                <div class="col-md-4">
                  <label class="po-label">Expected Date</label>
                  <input type="date" class="po-input" v-model="expected_date" />
                  <div v-if="errors.expected_date" class="po-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.expected_date[0] }}</div>
                </div>
 
              </div>
            </div>
          </div>
 
          <!-- ── Line Items ── -->
          <div class="po-card">
            <div class="po-card-head">
              <div class="po-card-icon" style="background:#fffbeb;"><i class="ti ti-list-details" style="color:#f59e0b;"></i></div>
              <span class="po-card-title">Purchase Order Items</span>
              <button type="button" class="po-add-item-btn ms-auto" @click="addItemRow">
                <i class="ti ti-plus"></i> Add Item
              </button>
            </div>
            <div class="po-card-body">
 
              <div v-for="(item, index) in items" :key="index" class="po-item-card">
                <div class="po-item-num">{{ index + 1 }}</div>
                <input type="hidden" v-model="item.hsn_code" />
 
                <div class="row g-2 align-items-end">
 
                  <!-- Item -->
                  <div class="col-md-4">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <label class="po-label mb-0">Item</label>
                      <a href="javascript:void(0);" class="po-add-item-link" @click="openAddItemModal(index)">
                        <i class="ti ti-plus" style="font-size:10px;"></i> New Item
                      </a>
                    </div>
                    <vue-select
                        :options="allItems"
                        v-model="item.item"
                        :get-option-label="item => `${item.name} - ${item.code ?? item.id}`"
                        @update:modelValue="val => onItemSelected(index, val)"
                        :disabled="!vendor_id"
                      />
                      <small v-if="!vendor_id" class="text-warning" style="font-size:10px; display:flex; align-items:center; gap:3px; margin-top:3px;">
                        <i class="ti ti-alert-triangle" style="font-size:11px;"></i> Please select vendor first
                      </small>
                    <div class="po-err-msg" v-if="getItemError(index, 'item_id')">
                      <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'item_id') }}
                    </div>
                  </div>
 
                  <!-- Tax -->
                  <div class="col-md-2">
                    <label class="po-label">Tax</label>
                    <vue-select
                      :options="taxes"
                      label="name"
                      v-model="item.selectedTax"
                      placeholder="Select tax"
                      @update:modelValue="val => onItemTaxSelected(index, val)"
                    />
                    <div class="po-err-msg" v-if="getItemError(index, 'tax_id')">
                      <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'tax_id') }}
                    </div>
                  </div>
 
                  <!-- Unit Cost -->
                  <div class="col-md-2">
                    <label class="po-label">Unit Cost</label>
                    <input type="number" class="po-input" v-model.number="item.price" @input="updateAmount(index)" placeholder="0.00" />
                    <div class="po-err-msg" v-if="getItemError(index, 'unit_price')">
                      <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'unit_price') }}
                    </div>
                  </div>
 
                  <!-- Qty -->
                  <div class="col-md-2">
                    <label class="po-label">Qty</label>
                    <input type="number" class="po-input" v-model.number="item.qty" @input="updateAmount(index)" placeholder="1" />
                    <div class="po-err-msg" v-if="getItemError(index, 'quantity')">
                      <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'quantity') }}
                    </div>
                  </div>
 
                  <!-- Amount -->
                  <div class="col-md-1">
                    <label class="po-label">Amount</label>
                    <input type="text" class="po-input" :value="getItemAmountDisplay(item).toFixed(2)" readonly
                      style="background:#f8fafc; font-weight:700; color:#1e293b;" />
                  </div>
 
                  <!-- Remove -->
                  <div class="col-md-1 d-flex align-items-end">
                    <button type="button" class="po-remove-btn" @click="removeItemRow(index)">
                      <i class="ti ti-trash"></i>
                    </button>
                  </div>
 
                </div>
              </div>
 
              <div v-if="!items.length" style="text-align:center;padding:28px;color:#94a3b8;">
                <i class="ti ti-inbox" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>
                No items added yet.
              </div>
 
            </div>
          </div>
 
          <!-- ── Notes ── -->
          <div class="po-card">
            <div class="po-card-head">
              <div class="po-card-icon" style="background:#faf5ff;"><i class="ti ti-notes" style="color:#8b5cf6;"></i></div>
              <span class="po-card-title">Notes</span>
            </div>
            <div class="po-card-body">
              <div class="row">
                <div class="col-md-6">
                  <textarea class="po-textarea" v-model="notes" placeholder="Add any notes for this purchase order..."></textarea>
                  <div class="po-err-msg" v-if="errors.notes"><i class="ti ti-alert-circle"></i>{{ errors.notes[0] }}</div>
                </div>
              </div>
            </div>
          </div>
 
          <!-- ── Pricing Summary ── -->
          <div class="po-card">
            <div class="po-card-head">
              <div class="po-card-icon" style="background:#f0fdf4;"><i class="ti ti-calculator" style="color:#16a34a;"></i></div>
              <span class="po-card-title">Pricing Summary</span>
            </div>
            <div class="po-card-body">
              <div style="max-width:380px; margin-left:auto;">
 
                <div class="po-price-row">
                  <span class="po-price-label">Subtotal</span>
                  <span class="po-price-val">{{ app_currency?.symbol }} {{ totalAmount.toFixed(2) }}</span>
                </div>
 
                <div class="po-price-row" v-if="taxAmount">
                  <span class="po-price-label">Item Taxes</span>
                  <span class="po-price-val" style="color:#2563eb;">{{ app_currency?.symbol }} {{ taxAmount.toFixed(2) }}</span>
                </div>
 
                <div class="po-grand-box">
                  <div class="po-grand-label"><i class="ti ti-check" style="font-size:13px;"></i> Grand Total</div>
                  <span class="po-grand-val">{{ app_currency?.symbol }} {{ grandTotal.toFixed(2) }}</span>
                </div>
 
              </div>
            </div>
          </div>
 
        </div><!-- /po-body -->
 
        <!-- Footer -->
        <div class="po-footer">
          <button type="button" class="po-btn po-btn-ghost me-auto" @click="addItemRow">
            <i class="ti ti-plus"></i> Add Item
          </button>
          <button type="button" class="po-btn po-btn-primary" @click="savePurchaseOrder">
            <i class="ti ti-device-floppy"></i> Save
          </button>
        </div>
 
      </form>
 
    </div>
  </div>
</div>
<!-- /ADD PURCHASE ORDER MODAL -->
 
 
<!-- ═══════════════════════════════════════════════
     RECEIVE STOCK MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="purchase_order_receive_stock_modal" tabindex="-1">
<div class="modal-dialog modal-xl">
<div class="modal-content" style="border:none; border-radius:16px; overflow:hidden;">
 
  <div class="modal-header" style="background:linear-gradient(135deg,#0f172a,#1e3a5f); border:none; padding:15px 20px;">
    <div>
      <h5 class="modal-title" style="color:#fff; font-weight:700; font-size:14px; margin:0;">
        {{ poReceiveNumber }} — Receive Stock
      </h5>
      <div style="font-size:11px; color:#64748b; margin-top:2px;">Enter received quantities and prices below</div>
    </div>
    <button class="btn-close btn-close-white" data-bs-dismiss="modal" style="opacity:.7;"></button>
  </div>
 
  <div class="modal-body" style="padding:20px; background:#f8fafc;">
 
    <!-- Info banner -->
    <div style="display:flex; align-items:center; gap:10px; padding:10px 14px; background:#eff6ff; border:1px solid #bfdbfe; border-radius:10px; margin-bottom:18px;">
      <i class="ti ti-info-circle" style="color:#3b82f6; font-size:16px; flex-shrink:0;"></i>
      <div>
        <span style="font-size:12.5px; font-weight:600; color:#1e40af;">
          {{ poReceiveData?.purchase_order_items?.length || 0 }} item(s) in this PO
        </span>
        <div v-if="clientSetting?.allow_inventory_variance" style="font-size:11px; color:#3b82f6; margin-top:1px;">
          Items within tolerance will be auto-approved; others will be flagged for review.
        </div>
      </div>
    </div>
 
    <!-- Invoice fields -->
    <div class="row g-3 mb-4">
      <div class="col-md-6">
        <label class="po-label">Invoice Number <span class="req" style="color:#f43f5e;">*</span></label>
        <input type="text" class="po-input" v-model="receiveInvoiceNumber" placeholder="Enter invoice number" />
        <div v-if="receiveInvoiceErrors.invoice_number" class="po-err-msg">
          <i class="ti ti-alert-circle"></i>{{ receiveInvoiceErrors.invoice_number[0] }}
        </div>
      </div>
<div class="col-md-6">
  <label class="po-label">Invoice Files <span class="req" style="color:#f43f5e;">*</span></label>

  <!-- hidden real input -->
  <input
    type="file"
    accept="image/*,application/pdf"
    multiple
    @change="handleReceiveInvoiceFiles"
    ref="receiveInvoiceInput"
    style="display:none;"
  />

  <!-- Add Image button -->
  <div
    @click="$refs.receiveInvoiceInput.click()"
    style="display:flex; align-items:center; justify-content:center; gap:8px; padding:14px; border:1.5px dashed #93c5fd; border-radius:9px; background:#eff6ff; color:#2563eb; font-size:12.5px; font-weight:600; cursor:pointer; transition:all .15s;"
    @mouseover="$event.currentTarget.style.background='#dbeafe'"
    @mouseleave="$event.currentTarget.style.background='#eff6ff'">
    <i class="ti ti-cloud-upload" style="font-size:18px;"></i>
    Add Images / PDF
    <span v-if="receiveInvoiceFiles.length" style="font-size:11px; color:#64748b;">
      ({{ receiveInvoiceFiles.length }} selected)
    </span>
  </div>

  <div v-if="receiveInvoiceErrors.invoice_files" class="po-err-msg">
    <i class="ti ti-alert-circle"></i>{{ receiveInvoiceErrors.invoice_files[0] }}
  </div>

  <!-- selected files preview -->
  <div v-if="receiveInvoiceFiles.length" style="margin-top:10px; display:flex; flex-direction:column; gap:6px;">
    <div v-for="(file, i) in receiveInvoiceFiles" :key="i"
      style="display:flex; align-items:center; gap:10px; padding:8px 10px; background:#fff; border:1px solid #e2e8f0; border-radius:9px;">
      <div :style="`width:32px; height:32px; border-radius:7px; display:flex; align-items:center; justify-content:center; flex-shrink:0; background:${file.type === 'application/pdf' ? '#fef2f2' : '#eff6ff'};`">
        <i :class="file.type === 'application/pdf' ? 'ti ti-file-type-pdf' : 'ti ti-photo'"
           :style="`font-size:16px; color:${file.type === 'application/pdf' ? '#ef4444' : '#3b82f6'};`"></i>
      </div>
      <div style="flex:1; overflow:hidden;">
        <div style="font-size:12px; font-weight:600; color:#1e293b; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
          {{ file.name }}
        </div>
        <div style="font-size:10.5px; color:#94a3b8;">{{ (file.size / 1024).toFixed(1) }} KB</div>
      </div>
      <button type="button" class="po-remove-btn" style="width:26px; height:26px; font-size:12px; flex-shrink:0;"
        @click="removeReceiveFile(i)">
        <i class="ti ti-x"></i>
      </button>
    </div>
  </div>
</div>
    </div>
 
    <!-- Items table -->
    <div style="background:#fff; border:1px solid #e2e8f0; border-radius:10px; overflow:hidden;">
      <table class="table mb-0 po-receive-table">
        <thead>
          <tr>
            <th>Item</th>
            <th>Ordered</th>
            <th>Received</th>
            <th>Remaining</th>
            <th>PO Price</th>
            <th>Received Qty</th>
            <th>Received Price</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in poReceiveData?.purchase_order_items" :key="item.id"
  :style="parseFloat(item.quantity_ordered) - parseFloat(item.received_quantity || 0) <= 0 ? 'opacity:0.4; pointer-events:none;' : ''">
            <td style="font-weight:600;">
              {{ item.item.name }}
              <br />
              <div v-if="item.receive_status === 'pending' && item.purchase_receipt_items && item.purchase_receipt_items.length > 0" 
                style="margin-top:4px; padding:3px 8px; background:#fffbeb; border:1px solid #fde68a; border-radius:6px; font-size:10px; font-weight:600; color:#b45309; display:inline-flex; align-items:center; gap:4px;">
                <i class="ti ti-clock-hour-3" style="font-size:11px;"></i> This item is waiting for pending variance approval
              </div>
            </td>
            <td>
              <span style="padding:2px 8px; background:#f0fdf4; color:#16a34a; border-radius:20px; font-size:11px; font-weight:600;">
                {{ parseInt(item.quantity_ordered) }}
              </span>
            </td>
            <td>
  <span style="padding:2px 8px; background:#eff6ff; color:#2563eb; border-radius:20px; font-size:11px; font-weight:600;">
    {{ parseInt(item.received_quantity || 0) }}
  </span>
</td>
<td>
  <span style="padding:2px 8px; border-radius:20px; font-size:11px; font-weight:600;"
    :style="(parseFloat(item.quantity_ordered) - parseFloat(item.received_quantity || 0)) > 0 ? 'background:#fef2f2; color:#ef4444;' : 'background:#f0fdf4; color:#16a34a;'">
    {{ parseInt(parseFloat(item.quantity_ordered) - parseFloat(item.received_quantity || 0)) }}
  </span>
</td>
            <td style="color:#2563eb; font-weight:600;">{{ app_currency?.symbol }}{{ parseFloat(item.unit_price).toFixed(2) }}</td>
            <td>
              <input type="number" class="po-input" style="width:100px;"
                v-model.number="receivedQuantities[item.id]"
                min="0" :max="parseFloat(item.quantity_ordered)" step="1" />
            </td>
            <td>
              <input type="number" class="po-input" style="width:110px;"
                v-model.number="receivedPrices[item.id]"
                min="0" step="1" />
            </td>
            <td>
              <button class="po-btn po-btn-ghost" style="padding:4px 10px; font-size:11px;"
                @click="receivedQuantities[item.id] = 0; receivedPrices[item.id] = parseFloat(item.unit_price)">
                <i class="ti ti-refresh"></i> Reset
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
 
  </div>
 
  <div class="modal-footer" style="border-top:1px solid #e2e8f0; padding:12px 20px; gap:8px;">
    <button class="po-btn po-btn-ghost" data-bs-dismiss="modal">Cancel</button>
    <button class="po-btn po-btn-primary" @click="saveReceivedStock" :disabled="loading">
      <span v-if="loading" class="spinner-border spinner-border-sm"></span>
      <i v-else class="ti ti-package"></i>
      Receive Stock
    </button>
  </div>
 
</div>
</div>
</div>
<!-- /RECEIVE STOCK MODAL -->
 
 
<!-- ═══════════════════════════════════════════════
     DELETE MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="purchase_order_delete_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content" style="border:none; border-radius:16px; overflow:hidden;">
<div class="modal-body" style="padding:32px 24px; text-align:center;">
  <div style="width:60px; height:60px; background:#fff0f3; border-radius:14px; display:flex; align-items:center; justify-content:center; margin:0 auto 16px;">
    <i class="ti ti-trash-x" style="font-size:26px; color:#f43f5e;"></i>
  </div>
  <h4 style="font-weight:700; color:#0f172a; margin-bottom:8px;">Delete Purchase Order?</h4>
  <p style="color:#64748b; font-size:13px; margin-bottom:24px;">This action cannot be undone. The selected purchase order will be permanently removed.</p>
  <div class="d-flex justify-content-center gap-3">
    <a href="javascript:void(0);" class="po-btn po-btn-ghost" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="po-btn po-btn-danger" @click="confirmDelete">
      <i class="ti ti-trash"></i> Yes, Delete
    </a>
  </div>
</div>
</div>
</div>
</div>
<!-- /DELETE MODAL -->
 
 
<!-- ═══════════════════════════════════════════════
     ACTIVITY / HISTORY MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="purchase_order_activity_modal">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content" style="border:none; border-radius:16px; overflow:hidden;">
    <div class="modal-header" style="background:#0f172a; border:none; padding:14px 18px;">
      <h4 class="modal-title" style="font-size:14px; font-weight:700; color:#fff; margin:0;">
        {{ po_number }} — History
      </h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"
        style="filter:invert(1); opacity:.6;">
        <i class="ti ti-x"></i>
      </button>
    </div>
    <div class="modal-body" style="padding:18px;">
 
      <div v-if="activities?.length">
        <div v-for="row in activities" :key="row.id"
          style="display:flex; align-items:flex-start; gap:12px; padding:10px 0; border-bottom:1px dashed #f1f5f9;">
          <div style="width:34px; height:34px; background:#fffbeb; border-radius:9px; display:flex; align-items:center; justify-content:center; flex-shrink:0;">
            <i class="ti ti-circle-dot" style="color:#f59e0b; font-size:13px;"></i>
          </div>
          <div>
            <p style="margin:0 0 3px; font-size:12.5px; color:#1e293b; font-weight:500;" v-html="row.description"></p>
            <p style="margin:0; font-size:11px; color:#94a3b8;">
              <i class="ti ti-clock-hour-3" style="margin-right:3px;"></i>
              {{ $formatDate(row.created_at, 'DD MMM YYYY, hh:mm a') }}
            </p>
          </div>
        </div>
      </div>
 
      <div v-else style="text-align:center; padding:28px; color:#94a3b8;">
        <i class="ti ti-history" style="font-size:28px; display:block; margin-bottom:6px; opacity:.4;"></i>
        No activity recorded yet.
      </div>
 
    </div>
  </div>
</div>
</div>
<!-- /ACTIVITY MODAL -->
 
<item-modal ref="itemModalRef" @updated="onItemAdded"></item-modal>
 
</template>